import { getRedirectWhiteListSpid, handleNotHKUserJump } from '@/business/wallet-area';
import { request } from '@tencent/ppd-base-libs';
import { ErrorCodesType, SimpleLogin, loginConfig } from '@tencent/wphk-act-base-api';
import { setRequest } from '@tencent/wphk-act-base-cgi';
import { hideLoading } from '@tencent/wphk-act-base-ui';
import { axios } from '@tencent/wphk-base-request';
import { to } from '@tencent/wphk-base-utils';
import { initRequestBlockInterceptors } from '@tencent/wphk-components-project-common';


// 注入axios至base-lib
request.init(axios);
// 注入request到cgi
setRequest(request);

/**
 * 登录配置
 * errorHandle 错误处理自定义方法
 */
const getLoginConfig = () => ({
  // 业务方标识：跳转 self_operate registerUid 页时作为 ?channel= 透传包名，
  // 由 self_operate 的 BUSINESS_CHANNEL_MAP 反查注册渠道（fstandby4）数字，提交 submit 时透传数字。
  // @ts-ignore 项目未引入 @types/node，process 类型沿用 main.ts 同款规避
  business: process.env.VUE_APP_PKGNAME,
  errorHandleConfig: {
    [ErrorCodesType.IS_NOT_HK_USER_CODES]: async (err, executeDefault) => {
      const [, spid] = await to(getRedirectWhiteListSpid());
      if (spid) {
        handleNotHKUserJump(spid);
        return;
      }
      executeDefault(true);
    },
  },
});

const simpleLogin = new SimpleLogin(request, getLoginConfig());

/**
 * CGI登录状态检测 + 自动登录
 * 自动检测登陆态、并实现自动登陆，同时拦截登陆超时后的请求
 */
initRequestBlockInterceptors({
  blockingRequest: {
    beforeLogin() {
      // 执行登陆操作前的处理，如关闭loading等，没有的话可不处理
      hideLoading();
    },
    getOAuthCode() {
      // 进行微信Auth登陆获取code
      simpleLogin.getWXOAuthCodeByJumpToWx({
        url: location.href,
      });
    },
    login: async (config) => {
      // 登录接口直接放行
      if (config.url === loginConfig.LoginSimpleApi) {
        return;
      }
      // 小程序跳转静态资源获取放行
      if (config.url?.includes('st.moneydata.hk/res/cc/mpRedirectMerchantConf/config.json')) {
        return;
      }
      // 登录promise函数处理
      await simpleLogin.waitLoginPromiseHandle();
    },
  },
});
